export enum BadgeSize {
  small = 'small',
  medium = 'medium',
  large = 'large'
}

export enum BadgeColor {
  default = 'default',
  info1 = 'info-1',
  info1alt = 'info-1-alt',
  info2 = 'info-2',
  info2alt = 'info-2-alt',
  info3 = 'info-3',
  info3alt = 'info-3-alt',
  info4 = 'info-4',
  info4alt = 'info-4-alt',
  info5 = 'info-5',
  info5alt = 'info-5-alt',
  info6 = 'info-6',
  highSeverity = 'severity-high',
  highSeverityAlt = 'severity-high-alt',
  moderateSeverity = 'severity-moderate',
  moderateSeverityAltA = 'severity-moderate-alt-a',
  moderateSeverityAltB = 'severity-moderate-alt-b',
  lowSeverity = 'severity-low',
  lowSeverityAltA = 'severity-low-alt-a',
  lowSeverityAltB = 'severity-low-alt-b',
  success = 'success',
  successAlt = 'success-alt'
}

export enum BadgeStyle {
  square = 'square',
  notification = 'notification',
  flag = 'flag'
}

export enum BadgeType {
  informational = 'informational',
  notification = 'notification'
}
